import http from "../../http-common";

class KidsHeightWeight {

  getById(id) {
    return http.get(`/kid-quality/${id}`);
  }

  getHeightWeightSample(id) {
    return http.get(`/kid-quality/sample/${id}`);
  }
  getHeightSample() {
    return http.get(`/kid-quality/heightsample`);
  }
  create(data) {
    return http.post("/kid-quality", data);
  }

  update(id, data) {
    return http.put(`/grade/${id}`, data);
  }

  delete(id) {
    return http.delete(`/kid-quality/weight/${id}`);
  }
  delete1(id) {
    return http.delete(`/kid-quality/height/${id}`);
  }

  deleteAll() {
    return http.delete(`/tutorials`);
  }

  findByTitle(title) {
    return http.get(`/tutorials?title=${title}`);
  }

  searchWeightHeight(date, status, idClass, codeOrName) {
    return http.get(`/kid-quality/search?date=${date}&status=${status}&idClass=${idClass}&codeOrName=${codeOrName}`);
  }

  findAllHeightWeightDataFromServe(){
    return http.get(`/kid-quality/sample/all-height-weight`)
  }
  //export excel
  getExportExcelWeightHeight(list){
    return http.get(`/kid-quality/export-height-weight-all-v3?idList=${list}`);
  }
  getExportExcelNew(list, idClass, date){
    return http.get(`/kid-quality/export-height-weight-month-final?idList=${list}&idClass=${idClass}&date=${date}`);
  }
  getExportExcelRecentData(list){
    return http.get(`/kid-quality/export-height-weight-recent?idList=${list}`);
  }
  getExportExcelHistoryRange(list, startDate, endDate){
    return http.get(`/kid-quality/export-height-weight-history-range?idList=${list}&startDate=${startDate}&endDate=${endDate}`);
  }
}

export default new KidsHeightWeight();